import { policiesDescriptor } from './policies.js';
import { acceptanceDescriptor } from './acceptance.js';
import { contentDescriptor } from './content.js';
import { aiSystemDescriptor } from './ai-system.js';
import { aiRequestDescriptor } from './ai-request.js';
import { aiUserDescriptor } from './ai-user.js';
import { aiLabProjectDescriptor } from './ai-lab-project.js';
import { promptDescriptor } from './prompt.js';
import { courseDescriptor } from './course.js';
import { certificateDescriptor } from './certificate.js';
import { aiSystemReviewDescriptor } from './ai-system-review.js';
import { wikiEntryDescriptor } from './wiki-entry.js';
import { journeyDefinitionDescriptor } from './journey-definition.js';
import { journeyExecutionDescriptor } from './journey-execution.js';
import { activityDescriptor } from './activity.js';
import { deliverableDescriptor } from './deliverable.js';
export const descriptors = [
    // Ported baseline (L1 CMS + acceptance vault)
    policiesDescriptor,
    acceptanceDescriptor,
    contentDescriptor,
    // AI Governance Platform — Marko spec (Layers 0–3)
    aiUserDescriptor, // L0 identity/party (Entra ID governed view)
    aiSystemDescriptor, // L1 AI Registry
    aiRequestDescriptor, // L1 AI Request Center (7-step BPM on coreBOS-A)
    aiLabProjectDescriptor, // L2 reserved workspace
    promptDescriptor, // L2/L3 versioned prompt library
    courseDescriptor, // L3 LMS
    certificateDescriptor, // L3 Art. 4 register
    aiSystemReviewDescriptor, // L1/L2 periodic AI Act oversight
    wikiEntryDescriptor, // L3 knowledge community
    // Agent spine (governance ADR-003) — FrankenKit successor surface.
    // Producer clients (evo-re-skill sidecar, future headless runner) converge here.
    journeyDefinitionDescriptor,
    journeyExecutionDescriptor,
    activityDescriptor,
    deliverableDescriptor,
    // L0 observability: ai_interaction lives in the dedicated store (connector-standard.md)
    // — not a pack descriptor; written by the ingest receiver, not a form-backed module.
];
